import SweetAlert from "@components/Feedback/SweetAlert/Index";

export const DeleteOptionComp = ({
  row,
  deleteFunction,
  onDelete,
  itemNameKey,
  deleteReduxAction,
  getConfirmMessage
}) => {

  const handleDeleteClick = async () => {
    const itemName = row[itemNameKey];

    const confirmMessage = typeof getConfirmMessage === 'function'
      ? getConfirmMessage(row)
      : `Esta ação será irreversível e excluirá o seguinte cadastro: <strong>${itemName}</strong>`;

    try {
      const confirmDelete = await SweetAlert.delete(confirmMessage);

      if (confirmDelete) {
        SweetAlert.loading();

        const response = await deleteFunction(row.id);

        if (response) {
          SweetAlert.success('Excluído!', 'O registro foi excluído com sucesso.');

          // remove do componente pai
          onDelete(row.id);

          // remove do redux, se passado
          if (typeof deleteReduxAction === 'function') {
            deleteReduxAction(row.id);
          }
        }
      }
    } catch (error) {
      const errorMessage = error.parsed?.message || 'Não foi possível excluir.';

      SweetAlert.errorHTML('Erro ao excluir', errorMessage);
      console.error(error);
    }

  };

  return (
    <i
      className="fa-solid fa-trash fs-6 text-danger"
      onClick={handleDeleteClick}
      title="Ícone para abrir o modal de exclusão"
      style={{
        cursor: 'pointer',
      }}
    />
  );
};
